import { render, staticRenderFns } from "./NewsAppStatisticsOverview.vue?vue&type=template&id=5119bbf6"
import script from "./NewsAppStatisticsOverview.js?vue&type=script&lang=js&external"
export * from "./NewsAppStatisticsOverview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports